module.exports = __webpack_public_path__ + "fonts/regular.d4e015de.woff2";